import React, {useEffect, useRef, useState} from 'react';
import { INITIAL_CREATE_MISSION_DATA, confirmSlideOverClose } from '../slideOverUnsavedChanges';
import useSlideOver from "../useSlideOver";
import useContext from "../../../hooks/useContext";

const SlideOverStructure = ({isShowing, children, width = 'lg:w-[800px]', showCV = false}) => {
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const prevShowingRef = useRef(false);
    const animationTimeoutRef = useRef(null);
    const { toggleSlideOver } = useSlideOver();
    const {
        removeAllParameters,
        slideOverType,
        slideOverHasUnsavedChanges,
        setSlideOverHasUnsavedChanges,
        setDataCreateMission,
    } = useContext();

    useEffect(() => {
        // Déclencher l'animation uniquement lors de l'ouverture (transition de false à true)
        if (isShowing && !prevShowingRef.current) {
            setShouldAnimate(true);
            // Retirer la classe d'animation après 300ms (durée de l'animation)
            if (animationTimeoutRef.current) {
                clearTimeout(animationTimeoutRef.current);
            }
            animationTimeoutRef.current = setTimeout(() => {
                setShouldAnimate(false);
            }, 300);
        }
        if (!isShowing) {
            setShouldAnimate(false);
            if (animationTimeoutRef.current) {
                clearTimeout(animationTimeoutRef.current);
            }
        }
        prevShowingRef.current = isShowing;

        return () => {
            if (animationTimeoutRef.current) {
                clearTimeout(animationTimeoutRef.current);
            }
        };
    }, [isShowing]);

    useEffect(() => {
        if (!isShowing) {
            setSlideOverHasUnsavedChanges(false);
        }
    }, [isShowing, setSlideOverHasUnsavedChanges]);

    const handleOverlayClick = () => {
        if (!confirmSlideOverClose(slideOverType, slideOverHasUnsavedChanges)) {
            return;
        }

        if (slideOverType === 'add_mission') {
            setDataCreateMission(INITIAL_CREATE_MISSION_DATA);
        }

        toggleSlideOver();
        removeAllParameters();
    };

    const handlePanelClick = (e) => {
        e.stopPropagation();
    };

    return (
        <>
            {isShowing ?
                <>
                    <div className="w-full h-full fixed inset-0 z-30" onClick={handleOverlayClick}>
                        <div className="w-full h-full duration-500 ease-out transition-all inset-0 absolute bg-gray-900 opacity-50"></div>
                        <div 
                            className={`w-full ${showCV ? 'lg:w-[1400px]' : width} bg-white h-full min-h-0 absolute right-0 z-30 flex flex-col ${shouldAnimate ? 'duration-300 ease-out transition-all animate-slideR' : ''}`}
                            onClick={handlePanelClick}
                        >
                            {children}
                        </div>
                    </div>
                </> : null}
        </>
    );
};

export default SlideOverStructure;